import {Fragment} from 'react'
import Box from '@mui/material/Box'
import ReportIcon from '@mui/icons-material/Report'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Header from './Header'

import './applicationError.scss'

const ApplicationError = () => (
  <Fragment>
    <Header />
    <Stack className='application-error'>
    <Typography variant='h4' color='primary' gutterBottom>Application Error Boundary</Typography>
    <ReportIcon color='primary' sx={{fontSize: '200px'}} />
    <Box>
      <Typography color='secondary' className='info' variant='body1' gutterBottom>
        Oops, an error has occured and we're unable to process your request.
        Our Engineers have been notified and this can probably be resolved with a browser refresh.
        If it persists, please reach out to customer care.
      </Typography>
    </Box>
  </Stack>
  </Fragment>
)

export default ApplicationError
